import { Injectable, Injector } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '../services/config.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

    constructor(private injector: Injector) { }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        // Skip assets as config might not be loaded yet
        if (request.url.includes('assets/')) {
            return next.handle(request);
        }

        try {
            // Use Injector to get ConfigService lazily to avoid circular dependency
            const configService = this.injector.get(ConfigService);

            // Accessing apiConfig will throw if _config is not loaded
            const token = configService.apiConfig.token;
            if (token) {
                request = request.clone({
                    setHeaders: {
                        token: token
                    }
                });
            }
        } catch (e) {
            // Config not loaded or error, proceed without token
        }

        return next.handle(request);
    }
}
